import { render } from "./DaftarGaleri.vue?vue&type=template&id=05d5cf97"
import script from "./DaftarGaleri.vue?vue&type=script&lang=js"
export * from "./DaftarGaleri.vue?vue&type=script&lang=js"

import "./DaftarGaleri.vue?vue&type=style&index=0&id=05d5cf97&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__